import { useState } from 'react'
import { colors } from '@fitpet/constants-global'
import { FitpetIcon } from '@fitpet/ui/components'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { LAYOUT_UNITS } from '@/constants/legacy/constLayout'
import useEventDetailEventTracker from '@/containers/event-tracker/event-detail.event-tracker'
import CouponDisabledImage from '@/images/coupon-disabled.svg'
import CouponImage from '@/images/coupon.svg'
import { doSetBottomSheetData } from '@/stores/reduxData'

interface CartOrderCouponNudgeButtonProps {
  onClick?: () => void
  isDisabled?: boolean
  adId?: string
  adName?: string
  adSlug?: string
}

export const CartOrderCouponNudgeButton = ({
  onClick,
  isDisabled = false,
  adName,
  adId,
  adSlug,
}: CartOrderCouponNudgeButtonProps) => {
  const { trackerClickEventsaleCouponButton } = useEventDetailEventTracker()

  const [isShow, setIsShow] = useState<boolean>(true)
  const dispatch = useDispatch()

  if (!isShow) {
    return null
  }

  const handleClick = () => {
    onClick?.()
    dispatch(doSetBottomSheetData({ isCartOrderCouponDownloadVisible: true }))

    if (adId) {
      trackerClickEventsaleCouponButton({
        buttonText: isDisabled ? '쿠폰 보기' : '결제 전에 쿠폰 챙겨 가세요',
        isLogin: true,
        adId: adId,
        adName,
        adSlug,
      })
    }
  }

  const handleCloseNudge = () => {
    setIsShow(false)
  }

  return (
    <StyledOrderCouponNudgeContainer>
      <StyledOrderCouponNudgeButton onClick={handleClick} isDisabled={isDisabled}>
        {!isDisabled ? (
          <>
            <div className="left">
              <CouponImage />
              <div>
                <span className="font-body3-bold gray-700">결제 전에 &nbsp;</span>
                <span className="font-body3-bold red-500">쿠폰 챙겨 가세요</span>
              </div>
            </div>
            <FitpetIcon icon="icChevronDown" size={20} color={colors.GRAY_700} />
          </>
        ) : (
          <>
            <div className="left">
              <CouponDisabledImage />
              <span className="font-body3-bold gray-700">쿠폰 보기</span>
            </div>
            <CloseIconContainer
              onClick={(e) => {
                e.stopPropagation()
                handleCloseNudge()
              }}
            >
              <FitpetIcon icon="icClose" size={20} color={colors.GRAY_700} />
            </CloseIconContainer>
          </>
        )}
      </StyledOrderCouponNudgeButton>
    </StyledOrderCouponNudgeContainer>
  )
}

const StyledOrderCouponNudgeContainer = styled.div`
  z-index: 5;
  position: fixed;
  width: 100%;
  max-width: ${LAYOUT_UNITS.BODY_MAX_WIDTH};
  padding: 1.2rem 1.6rem 1.6rem;
  bottom: calc(var(--safe-bottom-extra) + 5.6rem);

  .left {
    display: flex;
    align-items: center;
    gap: 0.8rem;
  }
`

const StyledOrderCouponNudgeButton = styled.button<{ isDisabled: boolean }>`
  width: 100%;
  padding: 1.2rem 1.6rem;
  border: 0.1rem solid ${({ theme, isDisabled }) => (isDisabled ? theme.color.gray400 : theme.color.red500)};
  border-radius: 0.8rem;
  background-color: ${({ theme }) => theme.color.grayWhite};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

const CloseIconContainer = styled.div`
  cursor: pointer;
`
